import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { PropuestaTecnicaConvenioDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class PropuestaTecnicaConvenioService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getPropuestaTecnicaConvenioPorEstudianteRelacionadoService(numeroIdentificacion: string): Observable<BodyListResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyListResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/estudianteRelacionado/' + numeroIdentificacion);
  }


  getPropuestaTecnicaConvenioPorNumeroDelegadoDocenteSolicitanteService(numeroIdentificacion: string): Observable<BodyListResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyListResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/numeroIdentificacion/delegadoDocente/' + numeroIdentificacion);
  }

  getPropuestaTecnicaConvenioService(): Observable<BodyListResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyListResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/todos');
  }

  guardarPropuestaTecnicaConvenioService(propuestaTecnicaConvenioDTO: PropuestaTecnicaConvenioDTO): Observable<BodyResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/propuestaTecnicaConvenio', propuestaTecnicaConvenioDTO);
  }

  guardarSiguienteEtapaPropuestaTecnicaConvenioService(propuestaTecnicaConvenioDTO: PropuestaTecnicaConvenioDTO, operacion: string): Observable<BodyResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/propuestaTecnicaConvenio/etapa/' + operacion, propuestaTecnicaConvenioDTO);
  }

  getPropuestaTecnicaConvenioPorCodigoService(codigo: string): Observable<BodyResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/' + codigo);
  }

  getPropuestaTecnicaConvenioPorFlujoNumeroIdentificacionService(codigoFlujo: string, numeroIdentificacion: string): Observable<BodyListResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyListResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/flujo/numeroIdentificacion/' + codigoFlujo + '/' + numeroIdentificacion);
  }

  getPropuestaTecnicaConvenioPorFlujoService(codigoFlujo: string): Observable<BodyListResponse<PropuestaTecnicaConvenioDTO>> {
    return this.http.get<BodyListResponse<PropuestaTecnicaConvenioDTO>>(API_URL + '/api/v1/propuestaTecnicaConvenio/flujo/' + codigoFlujo);
  }
}
